import moment from 'moment';
import React, { useEffect, useState } from 'react';
import firebase from '../../components/firebase/Firebase'
import Header from '../dashboard/components/Header';
// XLSX und FileSaver werden über CDN geladen (siehe index.html)
// jsPDF wird über CDN geladen (siehe index.html)
import deleteIcon from './assets/trash.svg'
import restoreIcon from './assets/restore.svg'

import './Search.css'

const Search = (props) => {
    const [search, setSearch] = useState("");
    const [users, setUsers] = useState([])
    const [totalHours, setTotalHours] = useState(0)
    const [searchResults, setSearchResults] = useState([])
    const [months] = useState(["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"])
    const [isSynced, setIsSynced] = useState(false)
    const [roleChangeLoading, setRoleChangeLoading] = useState(null)

    // ===== ERINNERUNGS-BANNER & CHECKBOX STATE =====
    const [selectedUsers, setSelectedUsers] = useState({})
    const [showBanner, setShowBanner] = useState(true)
    const [showReceipt, setShowReceipt] = useState(false)
    const [receiptData, setReceiptData] = useState([])

    // ===== EINLADUNGS-MODAL STATE =====
    const [showInviteModal, setShowInviteModal] = useState(false)
    const [inviteFirstName, setInviteFirstName] = useState("")
    const [inviteLastName, setInviteLastName] = useState("")
    const [inviteEmail, setInviteEmail] = useState("")
    const [invitePassword, setInvitePassword] = useState("")
    const [inviteLoading, setInviteLoading] = useState(false)
    const [inviteError, setInviteError] = useState("")
    const [inviteSuccess, setInviteSuccess] = useState("")

    useEffect(() => {
        if (isSynced) return

        Promise.all([
            firebase.database().ref('users/').once("value"),
            firebase.database().ref(`sheets/${moment().year()}`).once('value')
        ]).then(([snapshot, sheetSnapshot]) => {
            let usersObj = snapshot.val()
            let sheetObj = sheetSnapshot.val()

            let usersArr = []
            for (let key in usersObj) {
                let user = usersObj[key]
                usersArr.push({ ...user, uid: key, totalHours: sheetObj && sheetObj[key] && sheetObj[key][months[moment().month()]] })
            }

            const usersFinalArr = Array.from(usersArr).sort((a, b) => {
                const getLastName = (name) => {
                    if (!name) return '';
                    const parts = name.trim().split(/\s+/);
                    return parts.length > 1 ? parts[parts.length - 1] : name;
                };
                return getLastName(a.name).localeCompare(getLastName(b.name), 'de', { sensitivity: 'base' });
            });

            setIsSynced(true)
            setUsers(usersFinalArr)
        })
    }, [isSynced, months])

    useEffect(() => {
        let usersFiltered = users.filter((user) => user.name.toLowerCase().includes(search.trim().toLowerCase()))

        let totalHours = 0
        for (let i in usersFiltered) {
            if (usersFiltered[i].isDeleted) {
                continue
            }

            totalHours += usersFiltered[i].totalHours || 0
        }

        setTotalHours(totalHours)
        setSearchResults(usersFiltered)
    }, [search, users])

    const onSelectUser = (uid) => {
        props.history.push('dashboard/' + uid)
    }

    const updateUserState = (e, id) => {
        e.stopPropagation();
        if (window.confirm(`Sind Sie sicher, dass Sie diesen Benutzer ${!props.isViewingDeleted ? "deaktivieren" : "wiederherstellen"} möchten?`)) {
            firebase.database().ref(`users/${id}`).update({
                isDeleted: !props.isViewingDeleted
            }).then(res => {
                setIsSynced(false)
            }).catch(err => {
                console.log(err)
            })
        }
    }

    // ===== ROLLEN-VERWALTUNG (nur SuperAdmin editierbar) =====
    const getUserRole = (user) => {
        if (user.isSuperAdmin) return 'superadmin';
        if (user.isAdmin) return 'admin';
        return 'user';
    };

    const getRoleLabel = (role) => {
        switch (role) {
            case 'superadmin': return 'SuperAdmin';
            case 'admin': return 'Admin';
            default: return 'Benutzer';
        }
    };

    const changeUserRole = (e, uid, userName, newRole) => {
        e.stopPropagation();
        
        if (uid === props.user.uid) {
            alert('Sie können Ihre eigene Rolle nicht ändern.');
            return;
        }

        const roleLabel = getRoleLabel(newRole);
        if (!window.confirm(`Möchten Sie "${userName}" die Rolle "${roleLabel}" zuweisen?`)) {
            return;
        }

        setRoleChangeLoading(uid);

        const updates = {};
        switch (newRole) {
            case 'superadmin':
                updates.isSuperAdmin = true;
                updates.isAdmin = true;
                break;
            case 'admin':
                updates.isSuperAdmin = false;
                updates.isAdmin = true;
                break;
            default:
                updates.isSuperAdmin = false;
                updates.isAdmin = false;
                break;
        }

        firebase.database().ref(`users/${uid}`).update(updates)
            .then(() => {
                setRoleChangeLoading(null);
                setIsSynced(false);
            })
            .catch(err => {
                console.error('Fehler beim Ändern der Rolle:', err);
                alert('Fehler beim Ändern der Rolle: ' + err.message);
                setRoleChangeLoading(null);
            });
    };

    // ===== BENUTZER EINLADEN =====
    const generatePassword = () => {
        const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789!@#$%';
        let password = '';
        for (let i = 0; i < 12; i++) {
            password += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return password;
    };

    const openInviteModal = () => {
        setInviteFirstName("");
        setInviteLastName("");
        setInviteEmail("");
        setInvitePassword(generatePassword());
        setInviteError("");
        setInviteSuccess("");
        setInviteLoading(false);
        setShowInviteModal(true);
    };

    const closeInviteModal = () => {
        setShowInviteModal(false);
    };

    const inviteUser = () => {
        if (!inviteEmail.trim()) {
            setInviteError("Bitte geben Sie eine E-Mail-Adresse ein.");
            return;
        }
        if (!inviteFirstName.trim() || !inviteLastName.trim()) {
            setInviteError("Bitte geben Sie Vor- und Nachnamen ein.");
            return;
        }
        if (!invitePassword || invitePassword.length < 6) {
            setInviteError("Das Passwort muss mindestens 6 Zeichen lang sein.");
            return;
        }

        setInviteLoading(true);
        setInviteError("");

        // Sekundäre Firebase-App-Instanz verwenden, damit der aktuelle Benutzer nicht ausgeloggt wird
        const secondaryApp = firebase.apps.find(app => app.name === 'secondary') ||
            firebase.initializeApp({
                apiKey: "AIzaSyCzVInTjidYv-NFMXIpkGFfwXEwlI6qTUk",
                authDomain: "worktoday-2e027.firebaseapp.com",
                databaseURL: "https://worktoday-2e027-default-rtdb.firebaseio.com",
                projectId: "worktoday-2e027",
                storageBucket: "worktoday-2e027.appspot.com",
                messagingSenderId: "154691659253",
                appId: "1:154691659253:web:5e9d494114cf36f069ecbc",
            }, 'secondary');

        const secondaryAuth = secondaryApp.auth();
        const fullName = inviteFirstName.trim() + " " + inviteLastName.trim();

        secondaryAuth.createUserWithEmailAndPassword(inviteEmail.trim(), invitePassword)
            .then(userCredential => {
                const newUid = userCredential.user.uid;
                // Benutzer in der Datenbank anlegen (als normaler Benutzer)
                return firebase.database().ref('users/' + newUid).set({
                    email: inviteEmail.trim(),
                    name: fullName
                }).then(() => {
                    // Sekundäre Auth ausloggen
                    secondaryAuth.signOut();
                    setInviteSuccess(`Benutzer "${fullName}" wurde erfolgreich eingeladen.\n\nZugangsdaten:\nE-Mail: ${inviteEmail.trim()}\nPasswort: ${invitePassword}`);
                    setInviteLoading(false);
                    setIsSynced(false); // Benutzerliste neu laden
                });
            })
            .catch(err => {
                console.error('Fehler beim Einladen:', err);
                let errorMsg = 'Fehler beim Einladen: ';
                switch (err.code) {
                    case "auth/email-already-in-use":
                        errorMsg += "Diese E-Mail-Adresse wird bereits verwendet.";
                        break;
                    case "auth/invalid-email":
                        errorMsg += "Die E-Mail-Adresse ist ungültig.";
                        break;
                    case "auth/weak-password":
                        errorMsg += "Das Passwort ist zu schwach (mind. 6 Zeichen).";
                        break;
                    default:
                        errorMsg += err.message;
                        break;
                }
                setInviteError(errorMsg);
                setInviteLoading(false);
            });
    };

    const copyCredentials = () => {
        const text = `E-Mail: ${inviteEmail.trim()}\nPasswort: ${invitePassword}`;
        navigator.clipboard.writeText(text).then(() => {
            alert('Zugangsdaten wurden in die Zwischenablage kopiert.');
        }).catch(() => {
            // Fallback
            const textarea = document.createElement('textarea');
            textarea.value = text;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            alert('Zugangsdaten wurden in die Zwischenablage kopiert.');
        });
    };

    // ===== EXPORT-FUNKTIONEN =====
    const getExportData = () => {
        const activeUsers = searchResults.filter(u => !u.isDeleted);
        return activeUsers.map(user => {
            let val = (user.totalHours || 0) * 60 * 60;
            let hour = Math.floor(val / (60 * 60)) || 0;
            val = val - (hour * 60 * 60);
            let minute = Math.round((val / 60)) || 0;
            return {
                Name: reverseName(user.name),
                'E-Mail': user.email,
                'Stunden': hour,
                'Minuten': minute,
                'Total (dezimal)': user.totalHours ? parseFloat(user.totalHours.toFixed(2)) : 0
            };
        });
    };

    const exportToExcel = () => {
        const data = getExportData();
        const currentMonth = months[moment().month()];
        const year = moment().year();
        
        let totalVal = totalHours * 60 * 60;
        let totalHour = Math.floor(totalVal / (60 * 60)) || 0;
        totalVal = totalVal - (totalHour * 60 * 60);
        let totalMinute = Math.round((totalVal / 60)) || 0;
        
        data.push({
            Name: 'GESAMT',
            'E-Mail': '',
            'Stunden': totalHour,
            'Minuten': totalMinute,
            'Total (dezimal)': parseFloat(totalHours.toFixed(2))
        });
        
        try {
            const XLSX = window.XLSX;
            const ws = XLSX.utils.json_to_sheet(data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, `${currentMonth} ${year}`);
            
            ws['!cols'] = [
                { wch: 25 },
                { wch: 30 },
                { wch: 10 },
                { wch: 10 },
                { wch: 15 },
            ];
            
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            if (window.saveAs) {
                window.saveAs(blob, `Zeiterfassung_${currentMonth}_${year}.xlsx`);
            } else {
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `Zeiterfassung_${currentMonth}_${year}.xlsx`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            }
        } catch (err) {
            console.error('Excel Export Fehler:', err);
            alert('Fehler beim Excel-Export: ' + err.message);
        }
    };

    const exportToPDF = () => {
        try {
            const data = getExportData();
            const currentMonth = months[moment().month()];
            const year = moment().year();
            const fileName = `Zeiterfassung_${currentMonth}_${year}.pdf`;
            
            const { jsPDF } = window.jspdf;
            const doc = new jsPDF();
            
            doc.setFontSize(18);
            doc.text('Zeiterfassung - ' + currentMonth + ' ' + year, 14, 22);
            doc.setFontSize(10);
            doc.text('Erstellt am: ' + moment().format('DD.MM.YYYY HH:mm'), 14, 30);
            
            let totalVal = totalHours * 60 * 60;
            let totalHour = Math.floor(totalVal / (60 * 60)) || 0;
            totalVal = totalVal - (totalHour * 60 * 60);
            let totalMinute = Math.round((totalVal / 60)) || 0;
            
            const tableData = data.map(function(row) {
                return [
                    row.Name,
                    row['E-Mail'],
                    row['Stunden'] + ':' + String(row['Minuten']).padStart(2, '0') + ' h',
                    row['Total (dezimal)']
                ];
            });
            
            tableData.push([
                'GESAMT',
                '',
                totalHour + ':' + String(totalMinute).padStart(2, '0') + ' h',
                parseFloat(totalHours.toFixed(2))
            ]);
            
            doc.autoTable({
                head: [['Name', 'E-Mail', 'Zeit (Std:Min)', 'Total (dezimal)']],
                body: tableData,
                startY: 36,
                styles: { fontSize: 9 },
                headStyles: { fillColor: [41, 128, 185] },
                foot: [['GESAMT', '', totalHour + ':' + String(totalMinute).padStart(2, '0') + ' h', parseFloat(totalHours.toFixed(2))]],
                showFoot: 'lastPage'
            });
            
            try {
                doc.save(fileName);
            } catch (saveErr) {
                var pdfDataUri = doc.output('datauristring');
                var newWindow = window.open();
                if (newWindow) {
                    newWindow.document.write('<iframe width="100%" height="100%" src="' + pdfDataUri + '"></iframe>');
                } else {
                    var pdfBlob = doc.output('blob');
                    var blobUrl = URL.createObjectURL(pdfBlob);
                    window.location.href = blobUrl;
                }
            }
        } catch (err) {
            console.error('PDF Export Fehler:', err);
            alert('Fehler beim PDF-Export: ' + err.message);
        }
    };

    const permanentlyDeleteUser = (e, id, name) => {
        e.stopPropagation();
        if (!props.user.isSuperAdmin) {
            alert('Nur der SuperAdmin kann Benutzer endgültig löschen.');
            return;
        }
        if (window.confirm(`ACHTUNG: Sind Sie sicher, dass Sie "${name}" ENDGÜLTIG löschen möchten? Alle Daten dieses Benutzers werden unwiderruflich gelöscht!`)) {
            if (window.confirm(`Letzte Warnung: Diese Aktion kann NICHT rückgängig gemacht werden. Wirklich endgültig löschen?`)) {
                const deletePromises = [
                    firebase.database().ref(`users/${id}`).remove(),
                ];
                for (let year = 2020; year <= 2030; year++) {
                    deletePromises.push(firebase.database().ref(`days/${year}/${id}`).remove());
                    deletePromises.push(firebase.database().ref(`sheets/${year}/${id}`).remove());
                }
                Promise.all(deletePromises).then(() => {
                    alert(`Benutzer "${name}" wurde endgültig gelöscht.`);
                    setIsSynced(false);
                }).catch(err => {
                    console.log(err);
                    alert('Fehler beim Löschen: ' + err.message);
                });
            }
        }
    }

    const reverseName = (name) => {
        if (!name) return '';
        const parts = name.trim().split(/\s+/);
        if (parts.length <= 1) return name;
        const lastName = parts[parts.length - 1];
        const firstNames = parts.slice(0, -1).join(' ');
        return `${lastName} ${firstNames}`;
    };

    const formatHours = (totalHoursVal) => {
        let val = (totalHoursVal || 0) * 60 * 60;
        let hour = Math.floor(val / (60 * 60)) || 0;
        val = val - (hour * 60 * 60);
        let minute = Math.round((val / 60)) || 0;
        return `${hour}:${String(minute).padStart(2, '0')} h`;
    };

    // ===== CHECKBOX & ERINNERUNG FUNKTIONEN =====
    const monthNames = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
    const currentDay = moment().date();
    const currentMonthName = monthNames[moment().month()];
    const currentYear = moment().year();
    const showReminderBanner = currentDay >= 16 && currentDay <= 20 && showBanner;

    const toggleUserSelection = (uid, e) => {
        e.stopPropagation();
        setSelectedUsers(prev => {
            const next = { ...prev };
            if (next[uid]) {
                delete next[uid];
            } else {
                next[uid] = true;
            }
            return next;
        });
    };

    const toggleAllUsers = (e) => {
        e.stopPropagation();
        const activeFiltered = filteredUsersCalc.filter(u => !u.isDeleted);
        const allSelected = activeFiltered.every(u => selectedUsers[u.uid]);
        if (allSelected) {
            setSelectedUsers({});
        } else {
            const next = {};
            activeFiltered.forEach(u => { next[u.uid] = true; });
            setSelectedUsers(next);
        }
    };

    const selectedCount = Object.keys(selectedUsers).length;

    const sendReminderEmail = () => {
        const selectedEmails = [];
        const selectedNames = [];
        searchResults.forEach(u => {
            if (selectedUsers[u.uid] && u.email) {
                selectedEmails.push(u.email);
                selectedNames.push(reverseName(u.name));
            }
        });
        if (selectedEmails.length === 0) return;

        const subject = encodeURIComponent(`Erinnerung: Arbeitsstunden eintragen - ${currentMonthName} ${currentYear}`);
        const body = encodeURIComponent(
            `Guten Tag\n\nEs gibt bald wieder Zahltag und wir wollten dich erinnern, ob du alle Stunden bis Ende ${currentMonthName} eingetragen hast.\n\nFalls nicht dann trage deine Stunden bis spätestens den 20. des Monats ein.\n\nLink zur Zeiterfassung: https://worktoday-2e027.web.app\n\nLiebe Grüsse\nGabriela`
        );
        const bcc = selectedEmails.join(',');
        window.open(`mailto:?bcc=${bcc}&subject=${subject}&body=${body}`, '_self');

        // Quittung anzeigen
        const now = moment().format('DD.MM.YYYY HH:mm');
        setReceiptData(selectedNames.map((name, i) => ({ name, email: selectedEmails[i], time: now })));
        setShowReceipt(true);
        setSelectedUsers({});
    };

    const filteredUsersCalc = searchResults.filter(user => 
        (!props.isViewingDeleted && !user.isDeleted) || (props.isViewingDeleted && user.isDeleted)
    );
    const filteredUsers = filteredUsersCalc;

    const isSuperAdmin = props.user.isSuperAdmin;
    const isAdmin = props.user.isAdmin || props.user.isSuperAdmin;
    const showRoleColumn = isAdmin; // Admin und SuperAdmin sehen die Rolle-Spalte
    const showCheckboxColumn = isAdmin && !props.isViewingDeleted;

    return (
        <div className="dashboard-wrapper">
            <Header user={props.user} isBackNeeded={props.isViewingDeleted} />

            {/* ===== ERINNERUNGS-BANNER ===== */}
            {showReminderBanner && (
                <div className="reminder-banner">
                    <span>Bitte tragen Sie Ihre Arbeitsstunden bis zum 20. {currentMonthName} ein.</span>
                    <button className="banner-close" onClick={() => setShowBanner(false)}>&times;</button>
                </div>
            )}

            <div className="dashboard-utils">
                <input 
                    className="primary search"
                    type="text" name="email"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Nach Name suchen"
                />
                {
                    !props.isViewingDeleted && (
                        <button
                            className="primary red-button"
                            onClick={() => props.history.push('/deleted')}
                        >
                            Deaktivierte Benutzer anzeigen
                        </button>
                    )
                }

                {isAdmin && !props.isViewingDeleted && (
                    <button
                        className="primary invite-button"
                        onClick={openInviteModal}
                    >
                        + Benutzer einladen
                    </button>
                )}
                
                {isAdmin && !props.isViewingDeleted && (
                    <div className="export-buttons">
                        <button className="primary export-button excel-button" onClick={exportToExcel}>
                            📊 Excel herunterladen
                        </button>
                        <button className="primary export-button pdf-button" onClick={exportToPDF}>
                            📄 PDF herunterladen
                        </button>
                    </div>
                )}

                {showCheckboxColumn && selectedCount > 0 && (
                    <button className="primary reminder-send-button" onClick={sendReminderEmail}>
                        ✉ Erinnerung senden ({selectedCount})
                    </button>
                )}
            </div>
        
            <div className="user-table-container">
                <table className="user-table">
                    <thead>
                        <tr>
                            {showCheckboxColumn && (
                                <th className="col-checkbox" onClick={toggleAllUsers}>
                                    <input type="checkbox" checked={filteredUsers.length > 0 && filteredUsers.filter(u => !u.isDeleted).every(u => selectedUsers[u.uid])} readOnly />
                                </th>
                            )}
                            <th className="col-name">Name</th>
                            <th className="col-email">E-Mail-Adresse</th>
                            {showRoleColumn && <th className="col-role">Rolle</th>}
                            <th className="col-hours">Stunden</th>
                            <th className="col-actions">Aktion</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredUsers.map((user) => (
                            <tr key={user.uid} className={`user-row${selectedUsers[user.uid] ? ' row-selected' : ''}`} onClick={() => onSelectUser(user.uid)}>
                                {showCheckboxColumn && (
                                    <td className="col-checkbox" onClick={(e) => toggleUserSelection(user.uid, e)}>
                                        <input type="checkbox" checked={!!selectedUsers[user.uid]} readOnly />
                                    </td>
                                )}
                                <td className="col-name">{reverseName(user.name)}</td>
                                <td className="col-email">{user.email}</td>
                                {showRoleColumn && (
                                    <td className="col-role" onClick={(e) => e.stopPropagation()}>
                                        {isSuperAdmin ? (
                                            // SuperAdmin: editierbare Dropdowns (eigene Rolle als Badge)
                                            user.uid === props.user.uid ? (
                                                <span className="role-badge role-superadmin">SuperAdmin</span>
                                            ) : (
                                                <>
                                                    <select
                                                        className="role-select"
                                                        value={getUserRole(user)}
                                                        onChange={(e) => changeUserRole(e, user.uid, user.name, e.target.value)}
                                                        disabled={roleChangeLoading === user.uid}
                                                        title="Rolle ändern"
                                                    >
                                                        <option value="user">Benutzer</option>
                                                        <option value="admin">Admin</option>
                                                        <option value="superadmin">SuperAdmin</option>
                                                    </select>
                                                    {roleChangeLoading === user.uid && (
                                                        <span className="role-loading">...</span>
                                                    )}
                                                </>
                                            )
                                        ) : (
                                            // Admin: nur lesen (Badge)
                                            <span className={`role-badge role-${getUserRole(user)}`}>
                                                {getRoleLabel(getUserRole(user))}
                                            </span>
                                        )}
                                    </td>
                                )}
                                <td className="col-hours">{formatHours(user.totalHours)}</td>
                                <td className="col-actions" onClick={(e) => e.stopPropagation()}>
                                    <div className="action-buttons-table">
                                        <button
                                            className={user.isDeleted ? "btn-action btn-restore" : "btn-action btn-delete"}
                                            onClick={(e) => updateUserState(e, user.uid)}
                                            title={user.isDeleted ? "Wiederherstellen" : "Deaktivieren"}
                                        >
                                            <img src={user.isDeleted ? restoreIcon : deleteIcon} alt={user.isDeleted ? "restore" : "delete"} />
                                        </button>
                                        {props.user.isSuperAdmin && props.isViewingDeleted && (
                                            <button
                                                className="btn-action btn-permanent-delete"
                                                onClick={(e) => permanentlyDeleteUser(e, user.uid, user.name)}
                                                title="Endgültig löschen (SuperAdmin)"
                                            >
                                                ✖
                                            </button>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    {!props.isViewingDeleted && (
                        <tfoot>
                            <tr className="total-row">
                                {showCheckboxColumn && <td className="col-checkbox"></td>}
                                <td className="col-name"><strong>{months[moment().month()]} Gesamt</strong></td>
                                <td className="col-email"></td>
                                {showRoleColumn && <td className="col-role"></td>}
                                <td className="col-hours"><strong>{formatHours(totalHours)}</strong></td>
                                <td className="col-actions"></td>
                            </tr>
                        </tfoot>
                    )}
                </table>
            </div>

            {/* ===== EINLADUNGS-MODAL ===== */}
            {showInviteModal && (
                <div className="modal-overlay" onClick={closeInviteModal}>
                    <div className="modal-content invite-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2>Benutzer einladen</h2>
                            <button className="modal-close" onClick={closeInviteModal}>&times;</button>
                        </div>

                        {inviteSuccess ? (
                            <div className="modal-body">
                                <div className="invite-success">
                                    <div className="invite-success-icon">✓</div>
                                    <p><strong>Benutzer wurde erfolgreich eingeladen!</strong></p>
                                    <div className="invite-credentials">
                                        <p><strong>Zugangsdaten:</strong></p>
                                        <p>E-Mail: <code>{inviteEmail.trim()}</code></p>
                                        <p>Passwort: <code>{invitePassword}</code></p>
                                    </div>
                                    <p className="invite-hint">Bitte teilen Sie diese Zugangsdaten dem neuen Benutzer mit. Das Passwort kann nach dem ersten Login geändert werden.</p>
                                    <div className="modal-actions">
                                        <button className="primary invite-copy-btn" onClick={copyCredentials}>
                                            Zugangsdaten kopieren
                                        </button>
                                        <button className="primary blue-button" onClick={closeInviteModal}>
                                            Schliessen
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="modal-body">
                                {inviteError && (
                                    <div className="invite-error">{inviteError}</div>
                                )}
                                <div className="invite-form">
                                    <label>Vorname</label>
                                    <input
                                        className="primary"
                                        type="text"
                                        value={inviteFirstName}
                                        onChange={(e) => setInviteFirstName(e.target.value)}
                                        placeholder="Vorname"
                                        disabled={inviteLoading}
                                    />
                                    <label>Nachname</label>
                                    <input
                                        className="primary"
                                        type="text"
                                        value={inviteLastName}
                                        onChange={(e) => setInviteLastName(e.target.value)}
                                        placeholder="Nachname"
                                        disabled={inviteLoading}
                                    />
                                    <label>E-Mail-Adresse</label>
                                    <input
                                        className="primary"
                                        type="email"
                                        value={inviteEmail}
                                        onChange={(e) => setInviteEmail(e.target.value)}
                                        placeholder="E-Mail-Adresse"
                                        disabled={inviteLoading}
                                    />
                                    <label>Temporäres Passwort</label>
                                    <div className="password-row">
                                        <input
                                            className="primary"
                                            type="text"
                                            value={invitePassword}
                                            onChange={(e) => setInvitePassword(e.target.value)}
                                            placeholder="Passwort"
                                            disabled={inviteLoading}
                                        />
                                        <button
                                            className="primary password-generate-btn"
                                            onClick={() => setInvitePassword(generatePassword())}
                                            disabled={inviteLoading}
                                            title="Neues Passwort generieren"
                                        >
                                            ↻
                                        </button>
                                    </div>
                                </div>
                                <div className="modal-actions">
                                    <button
                                        className="primary blue-button"
                                        onClick={inviteUser}
                                        disabled={inviteLoading}
                                    >
                                        {inviteLoading ? 'Wird eingeladen...' : 'Einladen'}
                                    </button>
                                    <button
                                        className="primary"
                                        onClick={closeInviteModal}
                                        disabled={inviteLoading}
                                    >
                                        Abbrechen
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* ===== QUITTUNGS-MODAL ===== */}
            {showReceipt && (
                <div className="modal-overlay" onClick={() => setShowReceipt(false)}>
                    <div className="modal-content receipt-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2>Erinnerung gesendet</h2>
                            <button className="modal-close" onClick={() => setShowReceipt(false)}>&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="receipt-success-icon">✓</div>
                            <p>Die Erinnerungs-E-Mail wurde an folgende Mitarbeiter vorbereitet:</p>
                            <table className="receipt-table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>E-Mail</th>
                                        <th>Zeitpunkt</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {receiptData.map((item, i) => (
                                        <tr key={i}>
                                            <td>{item.name}</td>
                                            <td>{item.email}</td>
                                            <td>{item.time}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="modal-actions">
                                <button className="primary blue-button" onClick={() => setShowReceipt(false)}>
                                    Schliessen
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
 
export default Search;
